module.exports = __webpack_public_path__ + "static/media/followup_text_preview.dc1d1353.jpg";